import React, { useMemo } from "react";
import { Image } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

import {
  StyledFooter,
  StyledContainer,
  StyledAdjusted,
  StyledButton,
} from "./MainFooterStyles";

import { LIAA_WHITE, LOGO_WHITE } from "../../../images/imageSources";
import { scrollToTop } from "../../../helpers/globalFunctions";
import Typography from "../../atoms/Typography/Typography";
import { definedTypographyTypes } from "../../atoms/Typography/TypographyStyles";
import { styledWithTheme } from "../../../styles/theme";

const StyledLiLogo = styledWithTheme(Image)({
  "&&&": {
    marginLeft: "1em",
  },
});
const StyledLatviesiLogo = styledWithTheme(Image)({
  "&&&": {
    alignSelf: "center",
    marginRight: "auto",
  },
});
const StyledSponsorWrapper = styledWithTheme.div({
  "&&&": { marginLeft: "auto" },
});
const StyledInnerContainer = styledWithTheme.div({
  "&&&": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexWrap: "wrap",
  },
});

const IFrameFooter: React.FC = () => {
  const { t } = useTranslation();
  const { search } = useLocation();

  const liaa = useMemo(
    () => search?.split("&").find((quary) => quary.includes("liaa")),
    [search],
  );

  return (
    <StyledContainer>
      <StyledAdjusted>
        <StyledButton
          circular
          icon="angle up"
          floated="right"
          id="scrollToTopButton"
          onClick={scrollToTop}
        />
      </StyledAdjusted>
      <StyledFooter>
        <StyledInnerContainer>
          <StyledLatviesiLogo
            src={LOGO_WHITE}
            size="small"
            alt="logo"
            inline
            href="https://www.latviesi.com"
            target="_blank"
          />
          {liaa && (
            <StyledSponsorWrapper>
              <Typography
                type={definedTypographyTypes.title1}
                color="gray"
                as="span"
              >
                {t("sponsoredBy")}
              </Typography>
              <StyledLiLogo
                href="https://www.liaa.gov.lv/"
                target="_blank"
                src={LIAA_WHITE}
                width="400px"
                alt="logo"
                inline
              />
            </StyledSponsorWrapper>
          )}
        </StyledInnerContainer>
      </StyledFooter>
    </StyledContainer>
  );
};

export default IFrameFooter;
